import 'CssFolder/rating-input.scss';

// Incremental number used to generate unique instance id to uniquely identify the component
let instance = 0;

/**
 * Rating input component, displays a range of rating according to the size given.
 * A unqiue ID is generated for each input so that the label is able to match accordingly.
 * 
 * <i>Note that number + 1 is hardcoded rather than using a variable as it would make the dom flow more readable.</i>
 * 
 * @author Darrus Goh 
 */
export default function RatingInputComponent() {
    const UID = `rating${instance++}`;
    const DEFAULT_ONCHANGE = (value) => { console.log(`Rating Input Component: ${value}`) };

    const getName = (id) => {
        return id ? id : UID;
    };

    const getId = (id, number) => {
        return `${getName(id)}-${number}`;
    };

    return {
        view: ({ attrs: { id, value, required, minText, maxText, size, onchange = DEFAULT_ONCHANGE } }) => {
            return m('.rating', { class: required && !value ? 'is-invalid-custom' : '' },
                m('.rating-minmax-text', m("small", minText)),
                m('.rating-input-group',
                    [...Array(size).keys()].map(index => m('.rating-input',
                        m("label", { style: "cursor: pointer", for: getId(id, index + 1) }, index + 1),
                        m("input.form-check-input", {
                            type: "radio",
                            name: getName(id),
                            required,
                            id: getId(id, index + 1),
                            value: index + 1,
                            checked: value == (index + 1),
                            style: { cursor: "pointer" },
                            onclick: (e) => {
                                let number = Number(e.target.value);
                                if (value == number) {
                                    number = null;
                                }
                                onchange(number);
                            }
                        }),
                    ))
                ),
                m('.rating-minmax-text', m("small", maxText)),
            )
        }
    };
}